/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RabbitMQConfig,
  RabbitMQConfig$inboundSchema,
  RabbitMQConfig$Outbound,
  RabbitMQConfig$outboundSchema,
} from "./rabbitmqconfig.js";
import {
  RabbitMQCredentials,
  RabbitMQCredentials$inboundSchema,
  RabbitMQCredentials$Outbound,
  RabbitMQCredentials$outboundSchema,
} from "./rabbitmqcredentials.js";
import {
  Topics,
  Topics$inboundSchema,
  Topics$Outbound,
  Topics$outboundSchema,
} from "./topics.js";

export type DestinationUpdateRabbitMQ = {
  /**
   * "*" or an array of enabled topics.
   */
  topics?: Topics | undefined;
  /**
   * Optional JSON schema filter for event matching. Events must match this filter to be delivered to this destination.
   *
   * @remarks
   * Supports operators: $eq, $neq, $gt, $gte, $lt, $lte, $in, $nin, $startsWith, $endsWith, $exist, $or, $and, $not.
   * If null or empty, all events matching the topic filter will be delivered.
   * To remove an existing filter when updating a destination, set filter to an empty object `{}`.
   */
  filter?: { [k: string]: any } | null | undefined;
  config?: RabbitMQConfig | undefined;
  credentials?: RabbitMQCredentials | undefined;
  /**
   * Static key-value pairs merged into event metadata on every attempt.
   */
  deliveryMetadata?: { [k: string]: string } | null | undefined;
  /**
   * Arbitrary contextual information stored with the destination.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateRabbitMQ$inboundSchema: z.ZodType<
  DestinationUpdateRabbitMQ,
  z.ZodTypeDef,
  unknown
> = z.object({
  topics: Topics$inboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: RabbitMQConfig$inboundSchema.optional(),
  credentials: RabbitMQCredentials$inboundSchema.optional(),
  delivery_metadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "delivery_metadata": "deliveryMetadata",
  });
});
/** @internal */
export type DestinationUpdateRabbitMQ$Outbound = {
  topics?: Topics$Outbound | undefined;
  filter?: { [k: string]: any } | null | undefined;
  config?: RabbitMQConfig$Outbound | undefined;
  credentials?: RabbitMQCredentials$Outbound | undefined;
  delivery_metadata?: { [k: string]: string } | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateRabbitMQ$outboundSchema: z.ZodType<
  DestinationUpdateRabbitMQ$Outbound,
  z.ZodTypeDef,
  DestinationUpdateRabbitMQ
> = z.object({
  topics: Topics$outboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: RabbitMQConfig$outboundSchema.optional(),
  credentials: RabbitMQCredentials$outboundSchema.optional(),
  deliveryMetadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    deliveryMetadata: "delivery_metadata",
  });
});

export function destinationUpdateRabbitMQToJSON(
  destinationUpdateRabbitMQ: DestinationUpdateRabbitMQ,
): string {
  return JSON.stringify(
    DestinationUpdateRabbitMQ$outboundSchema.parse(destinationUpdateRabbitMQ),
  );
}
export function destinationUpdateRabbitMQFromJSON(
  jsonString: string,
): SafeParseResult<DestinationUpdateRabbitMQ, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationUpdateRabbitMQ$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationUpdateRabbitMQ' from JSON`,
  );
}
